/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrgCapabilitiesExternalApproval } from './orgCapabilitiesExternalApproval';


export interface TenantOrgCapabilitiesVmua { 
    external_approval?: OrgCapabilitiesExternalApproval;
}

